import React from 'react';
import { Box, Image } from '@chakra-ui/react';
import { SUPPORT_EMAIL } from '../constants';

interface SupportButtonProps {
  email?: string;
  subject?: string;
  body?: string;
  borderColor?: string;
  borderWidth?: string;
  hoverBorderColor?: string;
  hoverBackgroundColor?: string;
  backgroundColor?: string;
  size?: string;
  iconWidth?: string;
  iconHeight?: string;
  position?: 'absolute' | 'relative' | 'fixed' | 'sticky' | 'static';
  top?: string | number;
  right?: string | number;
  left?: string | number;
  zIndex?: number;
}

const SupportButton: React.FC<SupportButtonProps> = ({
  email = SUPPORT_EMAIL,
  subject = 'Support Request',
  body = '',
  borderColor = '#C6D959',
  borderWidth = '2px',
  hoverBorderColor = '#C6D959',
  hoverBackgroundColor = 'rgba(198, 217, 89, 0.1)',
  backgroundColor = 'rgba(28, 28, 30, 0.8)',
  size = '36px',
  iconWidth = '18',
  iconHeight = '18',
  position,
  top,
  right,
  left,
  zIndex
}) => {
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}${body ? `&body=${encodeURIComponent(body)}` : ''}`;

  return (
    <a
      href={mailtoLink}
      style={{ textDecoration: 'none', display: 'inline-flex' }}
    >
      <Box
        position={position}
        top={top}
        right={right}
        left={left}
        width={size}
        height={size}
        border={`${borderWidth} solid ${borderColor}`}
        borderRadius="50%"
        backgroundColor={backgroundColor}
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        zIndex={zIndex}
        _hover={{
          borderColor: hoverBorderColor,
          backgroundColor: hoverBackgroundColor
        }}
      >
        <Image
          src="/assets/images/support-icon.svg"
          alt="Support"
          width={iconWidth}
          height={iconHeight}
        />
      </Box>
    </a>
  );
};

export default SupportButton;
